import styled from 'styled-components';
import { CheckboxGroup } from '@app/components/common/Checkbox/Checkbox';

export const FilterCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
